// extracted by mini-css-extract-plugin
module.exports = {"formBlock":"_3fchT_hS9ng0ENWRZoJ0x"};